import React, {useEffect} from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import NativeSelect from '@material-ui/core/NativeSelect';
import InputBase from '@material-ui/core/InputBase';
import { MuiThemeProvider} from 'material-ui/styles';
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import {ThemeProvider} from "@material-ui/styles";
import TextField from "@material-ui/core/TextField";
const Theme = (borderRadius = '20px  0 0 20px', top = '-12px') => createMuiTheme({
    overrides: {
        MuiOutlinedInput: {
            root: {
                borderRadius: borderRadius,
            },
            input: {
                padding: '10.5px 14px',
            }
        },
        MuiFormLabel: {
            root: {
                lineHeight: 0
            }
        }
    },
    palette: {
        primary: {
            main: '#95c61c'
        },

        secondary: {
            main: '#95c61c',
            light: '#b2d164'
        },
    },
});


const useStyles = makeStyles((theme) => ({
    margin: {
        margin: theme.spacing(1),
    },
}));

export default function (props) {
    const classes = useStyles();
    const [age, setAge] = React.useState(props.value || '');
    useEffect(() => {
        setAge(props.value)
    });
    const handleChange = (event) => {
        setAge(event.target.value);
        props.onInput(event)
    };
    return (
        <div>
            <ThemeProvider  theme={Theme(props.borderRadius || '20px  0 0 20px')}>
            <FormControl style={{width: '130px'}}>
                <TextField value={age} name={'id'} id="filled-search" label={props.label || 'ID'} type="search" variant="outlined" onInput={handleChange}/>
            </FormControl>
            </ThemeProvider >
        </div>
    );
}
